import React, { useState, useEffect, useContext } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useHistory } from 'react-router-dom';
import { FaHome } from 'react-icons/fa';
import { toast } from 'react-toastify';
import axios from 'axios';
import logo from '../../asses/img/parkingl.png';
import * as ROUTES from '../../constans/rutas';
import { URL_EMPLOYEE } from '../../constans/servidor';
import AuthContex from '../../context/autenticacion/authContex';

const FacturacionPage = () => {
  const history = useHistory();
  const { usuario } = useContext(AuthContex);
  const [facturacionActiva, setFacturacionActiva] = useState(false);
  const [codigoServicio, setCodigoServicio] = useState('');
  const [observacion, setObservacion] = useState('');
  const [loading, setLoading] = useState(false);
  const [consultando, setConsultando] = useState(true);

  const observacionPorDefecto = () =>
    `Herramientas - ${usuario?.nombre || 'Usuario'}`;

  const esFacturacionActiva = (data) =>
    data?.prendido === true || data?.status === 1 || data?.status === '1';

  const aplicarRegistro = (data) => {
    const activa = esFacturacionActiva(data);
    setFacturacionActiva(activa);
    setCodigoServicio(data?.codigo_servicio || '');
  };

  const consultarEstado = async () => {
    setConsultando(true);
    try {
      const res = await axios.get(`${URL_EMPLOYEE}/invoiceSap`, {
        params: { op: 'list' },
      });
      if (res.data?.status && Array.isArray(res.data.data)) {
        const activo = res.data.data.find((item) => esFacturacionActiva(item));
        if (activo) {
          aplicarRegistro(activo);
        } else {
          setFacturacionActiva(false);
          setCodigoServicio('');
        }
      }
    } catch (error) {
      toast.error('No se pudo consultar el estado de la facturación');
    } finally {
      setConsultando(false);
    }
  };

  useEffect(() => {
    consultarEstado();
  }, []);

  useEffect(() => {
    if (usuario?.nombre) {
      setObservacion(observacionPorDefecto());
    }
  }, [usuario]);

  const handleEncender = async () => {
    if (!observacion.trim()) {
      toast.error('Ingrese una observación');
      return;
    }
    if (facturacionActiva) {
      toast.error('Ya hay una facturación encendida. Apáguela primero.');
      return;
    }

    setLoading(true);
    try {
      const body = { observacion: observacion.trim() };

      const crear = await axios.post(
        `${URL_EMPLOYEE}/invoiceSap?op=crear`,
        body
      );

      if (!crear.data?.status || !crear.data?.data?.codigo_servicio) {
        toast.error(crear.data?.message || 'No se pudo crear el registro');
        return;
      }

      const codigo = crear.data.data.codigo_servicio;

      const encender = await axios.post(
        `${URL_EMPLOYEE}/invoiceSap?op=encender&codigo=${codigo}`,
        body
      );

      if (encender.data?.status && encender.data?.data) {
        aplicarRegistro(encender.data.data);
        toast.success('Facturación encendida');
      } else {
        toast.error(encender.data?.message || 'No se pudo encender la facturación');
      }
    } catch (error) {
      toast.error('No se pudo encender la facturación');
    } finally {
      setLoading(false);
    }
  };

  const handleApagar = async () => {
    if (!codigoServicio.trim()) {
      toast.error('No hay código de servicio activo para apagar');
      return;
    }
    if (!observacion.trim()) {
      toast.error('Ingrese una observación');
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(
        `${URL_EMPLOYEE}/invoiceSap?op=apagar&codigo=${codigoServicio.trim()}`,
        { observacion: observacion.trim() }
      );
      if (res.data?.status && res.data?.data) {
        aplicarRegistro(res.data.data);
        setFacturacionActiva(false);
        setCodigoServicio('');
        setObservacion(observacionPorDefecto());
        toast.success('Facturación apagada');
      } else {
        toast.error(res.data?.message || 'No se pudo apagar la facturación');
      }
    } catch (error) {
      toast.error('No se pudo apagar la facturación');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Container className="contendor-Principal">
        <Row>
          <Col className="cont_logo" xs={12} sm={12} md={12} lg={12} xl={12}>
            <img className="logo" src={logo} alt="Logo" />
            <p className="texto-slogan">Facturacion</p>
          </Col>
        </Row>
        <Row className="justify-content-end">
          <Col
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontSize: '15px',
            }}
            className="cont_logo"
            xs={12}
            sm={12}
            md={6}
            lg={4}
            xl={4}
          >
            <Button
              style={{ marginRight: '10px' }}
              variant="primary"
              onClick={() => history.push(ROUTES.HOME)}
            >
              <FaHome size={20} style={{ marginRight: '5px' }} />
              HOME
            </Button>
          </Col>
        </Row>
      </Container>

      <Container>
        <Row className="justify-content-center mt-4">
          <Col xs={12} md={6} className="text-center">
            {consultando ? (
              <p>Consultando estado...</p>
            ) : (
              <>
                <p style={{ fontSize: '18px', marginBottom: '20px' }}>
                  Estado:{' '}
                  <strong>{facturacionActiva ? 'Encendida' : 'Apagada'}</strong>
                </p>
                {facturacionActiva && codigoServicio && (
                  <p style={{ fontSize: '14px', marginBottom: '20px', color: '#666' }}>
                    Código servicio: <strong>{codigoServicio}</strong>
                  </p>
                )}
                <Form.Group className="mb-4" style={{ maxWidth: '320px', margin: '0 auto' }}>
                  <Form.Label>Observación</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Modulo herramientas - Nombre usuario"
                    value={observacion}
                    onChange={(e) => setObservacion(e.target.value)}
                    disabled={loading}
                  />
                </Form.Group>
                <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
                  <Button
                    variant="success"
                    onClick={handleEncender}
                    disabled={loading || facturacionActiva}
                  >
                    {loading ? 'Procesando...' : 'Encender facturación'}
                  </Button>
                  <Button
                    variant="danger"
                    onClick={handleApagar}
                    disabled={loading || !facturacionActiva || !codigoServicio.trim()}
                  >
                    {loading ? 'Procesando...' : 'Apagar facturación'}
                  </Button>
                </div>
              </>
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default FacturacionPage;
